/**
 * 接口地址
 */
import { getEnvObj } from '@/utils/env'
// import { setPushConfigTmpToken } from './site'
const obj = getEnvObj()
const BASIC_ICAS = obj.API_ICAS_SERVICE
const BASIC_AUTH = obj.API_ICAS_AUTH
const BASIC_TIJI = obj.API_TIJI
const BASIC_RBAC = obj.API_ICAS_RBAC
export default {
  getHomeNotice: BASIC_ICAS + '/loginRegisterConfig/homePageNotices', // 获取sso跳转白名单
  /* 公共  */
  // getSfbuyNotice: getEnvObj().ENV === 'PRD' ? 'https://www.sfbuy.com/new/getNotices?currentPage=1' : 'https://sfbuy.sit.sf-express.com/new/getNotices?currentPage=1', // 获取sso跳转白名单
  getSfbuyNotice: getEnvObj().ENV === 'PRD' ? 'https://www.sfbuy.com/new/getNotices?currentPage=1' : 'https://sfbuy.sit.sf-express.com/new/getNotices?currentPage=1', // 获取sso跳转白名单

  whitelist: BASIC_AUTH + '/sso/whitelist', // 获取sso跳转白名单
  checkToken: BASIC_TIJI + '/login/check_token', // 检测token是否失效

  savePhoneAccountAbnormality: BASIC_ICAS + '/user/isolateBind', // 账号异常

  drainageLogin: BASIC_ICAS + '/auth/drainageLogin', // 引流登陆
  checkTencentCaptcha: BASIC_ICAS + '/notice/checkTencentCaptcha', // 腾讯图形验证码校验
  getPageRoute: BASIC_ICAS + '/auth/getPageRoute', // 定位新旧页面
  slideEmailPolicy: BASIC_ICAS + '/captcha/slideEmailPolicy', // 灰度接口（邮箱
  dictionary: BASIC_ICAS + '/dictionary/list', // 字典

  // 国家 public.js
  publicQueryPhoneRule: BASIC_ICAS + '/basicDataApi/queryPhoneRule', // 根据国家二字码获取国家电话规则
  // 验证码 public.js
  sendSmsCode: BASIC_ICAS + '/notice/smsCodeSf', // 手机验证码
  sendTencentSmsCode: BASIC_ICAS + '/notice/v2/smsCode', // 手机验证码【新接入腾讯验证码方案】
  sendEmailCode: BASIC_ICAS + '/notice/emailCode', // 邮箱验证码
  sendTencentEmailCode: BASIC_ICAS + '/notice/v2/emailCode', // 邮箱验证码【新接入腾讯验证码方案】
  checkValidateCode: BASIC_ICAS + '/notice/checkValidateCode', // 检验手机验证码是否正确
  // 滑块拼图验证 public.js
  slideCircus: BASIC_ICAS + '/captcha/slide', // 获取滑动验证图片
  // 条款相关 public.js
  getLatestTermRichText: BASIC_ICAS + '/term/richtext/getLatestTermRichText', // 获取最新可用条款文件id
  decrypt: BASIC_ICAS + '/userManage/showDecrypt', // 解密接口 v1.1
  /* 站点  site.js */
  siteList: BASIC_ICAS + '/loginRegisterConfig/briefs', // 生效的国家列表
  productUrl: BASIC_ICAS + '/public/productUrl', // 产品引导页获取产品引导
  separateSiteList: BASIC_ICAS + '/loginRegisterConfig/separate/briefs', // 生效的国家列表

  siteConfig: BASIC_ICAS + '/loginRegisterConfig/get', // 国家切换时，根据国家编码获取对应国家信息以及国家配置信息
  siteConfigSeparate: BASIC_ICAS + '/loginRegisterConfig/separate/get', // 国家切换时，根据国家编码获取对应国家信息以及国家配置信息
  mobileCountries: BASIC_ICAS + '/basicDataApi/queryCountryInfo', // 全部国家区号列表
  getSiteCode: BASIC_ICAS + '/loginRegisterConfig/getCountry', // 根据用户的ip去请求用户当前的国家编码（用户id后端去获取解析，前端只需要调用接口获取到国家编码即可）

  loginRegisterConfigExtend: BASIC_ICAS + '/loginRegisterConfig/extend', // 获取国家配置信息
  /* 注册 user.js */
  register: BASIC_ICAS + '/register', // 注册
  inexRegister: BASIC_ICAS + '/register/inexRegisterAndLogin', // inex注册
  /* 修改密码  user.js*/
  passModify: BASIC_ICAS + '/pass/modify', // 修改密码
  getConflictList: BASIC_ICAS + '/auth/getLoginConflictList', // 冲突 - 获取冲突列表
  passModifyConflict: BASIC_ICAS + '/pass/modifyConflict', // 冲突 - 修改密码
  resetByPhone: BASIC_ICAS + '/pass/resetByPhone', // 通过手机号重置密码
  resetByEmail: BASIC_ICAS + '/pass/resetByEmail', // 通过邮箱重置密码
  checkGrayVersion: '/icas-service-gray/checkGrayVersion', // 蓝绿环境刷新接口
  /* 登录  user.js*/
  login: BASIC_ICAS + '/auth/login', // 登录获取token
  accountDupCheckV2: BASIC_ICAS + '/user/accountCheck',
  accountDupCheck: BASIC_ICAS + '/user/accountDupCheck', // 检查是否出现重复账号
  replaceTokenRedirect: BASIC_ICAS + '/user/redirect', // 转换token 拼接到 redirectUrl并跳转  thirdLoginConfig: BASIC_ICAS + '/thirdUser/thirdLoginConfig', // 查看是否允许第三方登录
  thirdLoginConfig: BASIC_ICAS + '/thirdUser/thirdLoginConfig', // 查看是否允许第三方登录
  replaceTokenRedirectToken: BASIC_ICAS + '/user/redirectToken',

  loginV2: BASIC_ICAS + '/auth/v2/login', // 登录获取token（新接入腾讯验证码方案）
  loginGetTicket: BASIC_ICAS + '/auth/login/ticket', // 登录获取ticket
  loginGetTicketV2: BASIC_ICAS + '/auth/v2/login/ticket', // 登录获取ticket（新接入腾讯验证码方案）

  slidePolicy: BASIC_ICAS + '/captcha/slidePolicy', // 灰度接口 参考:https://confluence.sf-express.com/pages/viewpage.action?pageId=317339522
  logout: BASIC_TIJI + '/login/logout', // 退出登录
  cancelV2: BASIC_ICAS + '/user/v2/cancel', // 注销账号v2
  cancel: BASIC_ICAS + '/user/cancel', // 注销账号 v1.3.SP3
  langMapping: BASIC_ICAS + '/public/langMapping', // 获取目标国家的语言映射
  wxQrcode: BASIC_ICAS + '/auth/login/wx/qrcode', // 微信二维码创建
  thirdPartyQrcode: BASIC_ICAS + '/thirdUser/qrcode', // 生成第三方登录二维码
  loginThirdParty: BASIC_ICAS + '/public/loginThirdParty', // 第三方等你陆
  getTicketInfo: BASIC_ICAS + '/thirdUser/getTicketInfo', // 生成第三方登录二维码轮询遍历接口
  authRedirect: BASIC_AUTH + '/redirect', // 用于安全校验 跳转走后端
  qrcodeConfig: BASIC_ICAS + '/thirdUser/qrcodeConfig', // 获取qrcode配置
  wxQrcodepoll: BASIC_ICAS + '/auth/login/wx/qrcodepoll', // 轮询二维码是否失效
  checkLoginId: BASIC_ICAS + '/auth/check/loginId', // 轮训登陆结果
  getWxScanPageLoad: BASIC_ICAS + '/auth/getWxScanPageLoad', // 微信扫码登录开关
  // 邮件链接接口 user.js
  // activeUser: BASIC_ICRM + '/register/activeUser', // 激活用户接口
  // setPassword: BASIC_ICRM + '/register/setPassword', // 设置激活用户密码
  // 账号信息 user.js
  profile: BASIC_ICAS + '/user/loginUserInfo', // 获取我的账号基本信息
  genUsername: BASIC_ICAS + '/user/genUsername', // 自动生成用户名
  saveProfile: BASIC_ICAS + '/user/saveUserName', // 提交保存用户名
  setUserProperties: BASIC_ICAS + '/user/setUserProperties', // 提交firstName LastName
  bindTelOrMail: BASIC_ICAS + '/user/bindTelOrMail', // 绑定手机或邮箱
  modifyTelOrMail: BASIC_ICAS + '/user/modifyTelOrMail', // 更换手机或邮箱
  setPushConfig: BASIC_ICAS + '/user/setPushConfig', // 设置消息推送
  /* 鉴权系统 /permission */
  // 角色管理
  ROLE_LIST: BASIC_RBAC + '/role/list',
  ROLE_SAVE: BASIC_RBAC + '/role/save',
  ROLE_UPDATE: BASIC_RBAC + '/role/update',
  ROLE_DELETE: BASIC_RBAC + '/role/delete',
  ROLE_ENABLE: BASIC_RBAC + '/role/enable', // 启用、禁用
  ROLE_RESOURCE_LIST: BASIC_RBAC + '/role/resource/list', // 查询角色已绑定的资源
  ROLE_RESOURCE_SAVE: BASIC_RBAC + '/role/resource/save', // 保存角色所选资源

  // 用户管理
  USER_LIST: BASIC_RBAC + '/sys/user/list',
  USER_ROLE_LIST: BASIC_RBAC + '/sys/user/chose',
  USER_ROLE_SAVE: BASIC_RBAC + '/sys/user/haveRole',
  RESOURCE_LIST: BASIC_RBAC + '/resource/{systemSid}/children',

  // 系统管理
  addSystem: BASIC_RBAC + '/sys/system/save', // 系统新增
  updateSystem: BASIC_RBAC + '/sys/system/update', // 系统修改
  childrenSystem: BASIC_RBAC + '/sys/system/list', // 子类系统查询
  querySystem: BASIC_RBAC + '/sys/system/listByParams', // 系统条件查询
  deleteSystem: BASIC_RBAC + '/sys/system/delete', // 删除
  ableSystem: BASIC_RBAC + '/sys/system/able', // 启、禁用
  systemListPage: BASIC_RBAC + '/sys/system/listPageByParams', // 分页列表

  // 资源管理
  resourceAdd: BASIC_RBAC + '/resource/add', // 新增
  resourceBatchDelete: BASIC_RBAC + '/resource/batchDelete', // 批量删除
  resourceList: BASIC_RBAC + '/resource/children', // 资源列表
  resourceEnable: BASIC_RBAC + '/resource/enable', // 禁，启用
  resourceModify: BASIC_RBAC + '/resource/modify', // 修改
  resourcePrompt: BASIC_RBAC + '/resource/prompt', // 模糊查询
  resourceRemove: BASIC_RBAC + '/resource/remove', // 删除
  resourceRouteByLeaf: BASIC_RBAC + '/resource/routeByLeaf', // 返回查询根节点

  // 签署管理
  getCurrentUserTermSignRecords: BASIC_ICAS + '/term/richtext/getCurrentUserTermSignRecords', // 查询当前用户的签约列表
  getTermRichTextById: BASIC_ICAS + '/term/richtext/getTermRichTextById', // 下拉获取协议类型
  signList: BASIC_ICAS + '/dictionary/list', // 下拉获取协议类型

  getSmsNoticeChannel: BASIC_ICAS + '/notice/smsNoticeChannel', // 获取短信渠道 https://confluence.sf-express.com/pages/viewpage.action?pageId=354454807
  pwValidateCheck: BASIC_ICAS + '/public/pwValidateCheck', // 校验密码是否正确

  // /user/setPushConfigTmpToken
  setPushConfigTmpToken: BASIC_ICAS + '/user/setPushConfigTmpToken', // 设置消息推送临时token
  createPassword: BASIC_ICAS + '/user/createPassword', // 创建密码
  isolateTwoFactorBind: BASIC_ICAS + '/user/isolateTwoFactorBind', // 隔离2FA绑定

}
